function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isScrollable } from "../../../../src/shared/utils/isScrollable.js";
export var ScrollLock = /*#__PURE__*/function () {
  function ScrollLock(fancybox) {
    _classCallCheck(this, ScrollLock);

    this.fancybox = fancybox;
    this.viewport = null;
    this.pendingUpdate = null;

    for (var _i = 0, _arr = ["onReady", "onResize", "onTouchstart", "onTouchmove"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      this[methodName] = this[methodName].bind(this);
    }
  }
  /**
   * Process `initLayout` event to attach event listeners and resize viewport if needed
   */


  _createClass(ScrollLock, [{
    key: "onReady",
    value: function onReady() {
      //* Support Visual Viewport API
      // https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API
      var viewport = window.visualViewport;

      if (viewport) {
        this.viewport = viewport;
        this.startY = 0;
        viewport.addEventListener("resize", this.onResize);
        this.updateViewport();
      } //* Prevent bouncing while scrolling on mobile devices


      window.addEventListener("touchstart", this.onTouchstart, {
        passive: false
      });
      window.addEventListener("touchmove", this.onTouchmove, {
        passive: false
      }); //* Prevent window scrolling with mouse wheel

      window.addEventListener("wheel", this.onWheel, {
        passive: false
      });
    }
    /**
     * Handle `resize` event to call `updateViewport`
     */

  }, {
    key: "onResize",
    value: function onResize() {
      this.updateViewport();
    }
    /**
     * Scale $container proportionally to actually fit inside browser,
     * e.g., disable viewport zooming
     */

  }, {
    key: "updateViewport",
    value: function updateViewport() {
      var fancybox = this.fancybox,
          viewport = this.viewport,
          scale = viewport.scale || 1,
          $container = fancybox.$container;

      if (!$container) {
        return;
      }

      var width = "",
          height = "",
          transform = "";

      if (scale - 1 > 0.1) {
        width = "".concat(viewport.width * scale, "px");
        height = "".concat(viewport.height * scale, "px");
        transform = "translate3d(".concat(viewport.offsetLeft, "px, ").concat(viewport.offsetTop, "px, 0) scale(").concat(1 / scale, ")");
      }

      $container.style.width = width;
      $container.style.height = height;
      $container.style.transform = transform;
    }
    /**
     * Handle `touchstart` event to mark drag start position
     * @param {Object} event
     */

  }, {
    key: "onTouchstart",
    value: function onTouchstart(event) {
      this.startY = event.touches ? event.touches[0].screenY : event.screenY;
    }
    /**
     * Handle `touchmove` event to fix scrolling on mobile devices (iOS)
     * @param {Object} event
     */

  }, {
    key: "onTouchmove",
    value: function onTouchmove(event) {
      var startY = this.startY;
      var zoom = window.innerWidth / window.document.documentElement.clientWidth;

      if (!event.cancelable) {
        return;
      }

      if (event.touches.length > 1 || zoom !== 1) {
        return;
      }

      var el = isScrollable(event.composedPath()[0]);

      if (!el) {
        event.preventDefault();
        return;
      }

      var style = window.getComputedStyle(el);
      var height = parseInt(style.getPropertyValue("height"), 10);
      var curY = event.touches ? event.touches[0].screenY : event.screenY;
      var isAtTop = startY <= curY && el.scrollTop === 0;
      var isAtBottom = startY >= curY && el.scrollHeight - el.scrollTop === height;

      if (isAtTop || isAtBottom) {
        event.preventDefault();
      }
    }
    /**
     * Handle `wheel` event
     */

  }, {
    key: "onWheel",
    value: function onWheel(event) {
      if (!isScrollable(event.composedPath()[0])) {
        event.preventDefault();
      }
    }
    /**
     * Clean everything up
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.pendingUpdate) {
        cancelAnimationFrame(this.pendingUpdate);
        this.pendingUpdate = null;
      }

      var viewport = this.viewport;

      if (viewport) {
        viewport.removeEventListener("resize", this.onResize);
        this.viewport = null;
      }

      window.removeEventListener("touchstart", this.onTouchstart, false);
      window.removeEventListener("touchmove", this.onTouchmove, false);
      window.removeEventListener("wheel", this.onWheel, {
        passive: false
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      this.fancybox.on("initLayout", this.onReady);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.fancybox.off("initLayout", this.onReady);
      this.cleanup();
    }
  }]);

  return ScrollLock;
}();